import React, { useEffect } from 'react';
import HlFundingGuide from './HlFundingGuide';
import './SingleAssetHlPortfolio.css';
import './HlFundingGuide.css';
import './HlFundUsdcPanel.css';

export default function HlFundUsdcModal({
  open,
  onClose,
  walletAddress,
  variant = 'default',
  onFunded,
}) {
  useEffect(() => {
    if (!open) return undefined;
    const onKey = (e) => {
      if (e.key === 'Escape') onClose?.();
    };
    document.addEventListener('keydown', onKey);
    document.body.style.overflow = 'hidden';
    return () => {
      document.removeEventListener('keydown', onKey);
      document.body.style.overflow = '';
    };
  }, [open, onClose]);

  if (!open || !walletAddress) return null;

  return (
    <div className="sahl-portfolio-overlay" role="presentation" onClick={onClose}>
      <div
        className="sahl-portfolio-dialog hl-fund-modal-dialog hl-fund-modal-wide"
        role="dialog"
        aria-modal="true"
        aria-labelledby="hl-fund-modal-title"
        onClick={(e) => e.stopPropagation()}
      >
        <header>
          <h2 id="hl-fund-modal-title">Fund Hyperliquid</h2>
          <button type="button" className="sahl-portfolio-close" onClick={onClose} aria-label="Close">
            ×
          </button>
        </header>
        <p className="sahl-portfolio-hint">
          Step-by-step funding — USDC on Arbitrum, SOL via Phantom, or get USDC from an exchange. After credit,
          retry builder approval or live trading.
        </p>
        <HlFundingGuide
          walletAddress={walletAddress}
          variant={variant}
          embedded
          defaultTab="checklist"
          onBalanceChange={() => onFunded?.()}
        />
      </div>
    </div>
  );
}
